// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-details-page {
    background-color: #150924;
}

.blog-header {
    text-align: center;
    margin-bottom: 20px;
}

.blog-header img {
    width: 100%;
}

.sub-section {
    padding-top: 20px;
    align-items: center;
}

.blog-details-wrap {
    padding: 0px 100px;
}

.main-heading {
    font-size: 42px;
    font-weight: 700;
    line-height: 68px;
    color: #ffffff;
    padding-top: 58px;
}

.main-content {
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    padding-bottom: 57px;
    text-align: left;
    color: white;
}

.post-date {
    margin-bottom: 44px;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    color: #ffff;
    opacity: 0.8;
}

.sub-image {
    width: 100%;
    border-radius: 8px;
}

.sub-content .sub-heading {
    font-size: 32px;
    font-weight: 700;
    line-height: 68px;
    margin-bottom: 20px;
    color: #ffff;
}

.sub-content .description {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    text-align: left;
}

@media(max-width:768px) {
    .blog-details-wrap {
        padding: 0px 30px;
    }

    .main-heading {
        font-size: 25px;
        line-height: 39px;
        padding-top: 35px;
    }

    .sub-content .sub-heading {
        font-size: 25px;
        line-height: 39px;
    }

    .post-date {
        font-size: 15px;
    }

    .sub-content .description {
        font-size: 15px;
        line-height: 26px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BlogDetailsPage/BlogDetailsPage.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".blog-details-page {\n    background-color: #150924;\n}\n\n.blog-header {\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.blog-header img {\n    width: 100%;\n}\n\n.sub-section {\n    padding-top: 20px;\n    align-items: center;\n}\n\n.blog-details-wrap {\n    padding: 0px 100px;\n}\n\n.main-heading {\n    font-size: 42px;\n    font-weight: 700;\n    line-height: 68px;\n    color: #ffffff;\n    padding-top: 58px;\n}\n\n.main-content {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    padding-bottom: 57px;\n    text-align: left;\n    color: white;\n}\n\n.post-date {\n    margin-bottom: 44px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 26px;\n    color: #ffff;\n    opacity: 0.8;\n}\n\n.sub-image {\n    width: 100%;\n    border-radius: 8px;\n}\n\n.sub-content .sub-heading {\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 68px;\n    margin-bottom: 20px;\n    color: #ffff;\n}\n\n.sub-content .description {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    text-align: left;\n}\n\n@media(max-width:768px) {\n    .blog-details-wrap {\n        padding: 0px 30px;\n    }\n\n    .main-heading {\n        font-size: 25px;\n        line-height: 39px;\n        padding-top: 35px;\n    }\n\n    .sub-content .sub-heading {\n        font-size: 25px;\n        line-height: 39px;\n    }\n\n    .post-date {\n        font-size: 15px;\n    }\n\n    .sub-content .description {\n        font-size: 15px;\n        line-height: 26px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
